module.exports = __webpack_public_path__ + "img/jiaoxue_difficulty_show_bg.5f47cf5e.png";